// extracted by mini-css-extract-plugin
export default {"wrapper":"EC-z","viewport":"FC-z","container":"GC-z","slide":"HC-z"};